import type {AxiosError} from 'axios';

/** Only a same-origin, explicit browser-session denial should sign the UI out. */
export function isEndedBrowserSession(
  error: AxiosError,
  baseUri: string,
  currentOrigin: string,
): boolean {
  const data = error.response?.data as {session_ended?: unknown} | undefined;
  if (
    error.response?.status !== 401 ||
    data?.session_ended !== true ||
    !error.config?.url
  ) {
    return false;
  }
  try {
    const base = error.config.baseURL
      ? new URL(error.config.baseURL, baseUri).href
      : baseUri;
    return new URL(error.config.url, base).origin === currentOrigin;
  } catch {
    return false;
  }
}
